import React, { Component } from 'react'
import ContentInfo from '../_ContentInfo'

import FontIcon from '../../../../../SPRINTA/atoms/FontIcon'
import Calendar from '../../../../../v2SPRINTA/molecules/Calendar'
import Loading from '../../../../../v2SPRINTA/atoms/Loading'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { Text, FormGroup } from '../../../../../v2SPRINTA/atoms/Form'
import Checktag from '../../../../../v2SPRINTA/atoms/Form/Checktag'
import { Row, Col } from '../../../../../v2SPRINTA/atoms/Grid'
import Button from '../../../../../v2SPRINTA/atoms/Button'
import ScrollTo, { calcDistanceElement } from '../../../../../SPRINTA/atoms/ScrollTo'
import ActionBtnIcon from '../../../../../SPRINTA/molecules/ActionBtnIcon'

import { addDate, loadDates, loadDate, removeDate } from '../../_utils'
import { numberFormat, toDecimal } from '../../../../../SPRINTA/helpers/Formatter'

import Dialog from '../../../../../v2SPRINTA/molecules/Dialog'
import AccordionSection from '../../../../../v2SPRINTA/molecules/AccordionSection'

import { toDate, dateFormat } from '../../../../../SPRINTA/helpers/Formatter'

import css from './style.module.css'

const months = {
    "01": "Janeiro",
    "02": "Fevereio",
    "03": "Março",
    "04": "Abril",
    "05": "Maio",
    "06": "Junho",
    "07": "Julho",
    "08": "Agosto",
    "09": "Setembro",
    "10": "Outubro",
    "11": "Novembro",
    "12": "Dezembro",
}

function formatedDate(date) {
    date = date.split('-')
    return (
        <span><b>{date[2]} {months[date[1]]}</b> de {date[0]}</span>
    )
}

class CalendarStep extends Component {
    state = {
        date: null,
        dates: null,
        dateStatus: 'loading',
        dateEditing: [],
        deleteTimes: [],
        error: null,
        duplicateUntil: '',
        duplicateWeekDays: [],
        disabledcalendar: false,
        changeValue: ''
    }


    constructor(props) {
        super(props)

        loadDates(props.token)
        .then(resp => {
            let dates = {}
            resp.dates.forEach(date => {
                dates[date.date] = {
                    id: date.id
                }
            })
        
            this.setState({
                dates,
                dateStatus: null
            })
        })

    }

    setDate(date) {
        this.setState({
            dateStatus: 'loadingDate',
            dateEditing: [],
            date,
            deleteTimes: [],
            duplicateUntil: '',
            duplicateWeekDays: [],
            error: null,
            disabledcalendar: true
        }, () => {
            ScrollTo(calcDistanceElement(this.refs.input_dates.refs.div) - 90)
        })

        let wait = new Promise(resolve => {
            
            if(this.state.dates[date]) {
                loadDate(this.props.token, this.state.dates[date].id)
                .then(resp => {
                    let times = []
                    resp.result.times.forEach(item => {
                        const { time, vacancies, price, description, id } = item

                        times.push({
                            time,
                            vacancies,
                            price: numberFormat(price/100, 2, ',', '.'), 
                            id,
                            idEl: id,
                            description
                        })
                    })

                    resolve(times)
                })
            } else {   
                resolve([])
            }
        })

        wait.then(dateEditing => {
            this.setState({
                dateEditing: dateEditing,
                dateStatus: null,
                disabledcalendar: false
            }, () => { 
                if(this.state.dateEditing.length === 0)
                this.addNewTime()
            })
        })
        
    }

    handleChangeTime(inx, target) {
        let dateEditing = this.state.dateEditing
        dateEditing[inx][target.name] = target.value
        this.setState({
            dateEditing
        })
    }

    removeTime(inx) {
        let dateEditing = this.state.dateEditing
        let deleteTimes = this.state.deleteTimes
        if(dateEditing[inx].id)
        deleteTimes.push(dateEditing[inx].id)
        
        dateEditing.splice(inx, 1)
        this.setState({
            dateEditing,
            deleteTimes
        })
    }

    validate() {
        var errors = []
        
        if(Object.keys(this.state.dates).length === 0) {
            errors.push({
                element: this.calendar,
                error: "Você precisa cadastrar pelo menos uma data"
            })
        }
        
        let futureDates = Object.keys(this.state.dates).filter((item) => {
            var date = toDate(item).getTime()
            var today = new Date().getTime()
            return date > today;   
        })

        if(futureDates.length === 0) {
            errors.push({
                element: this.calendar,
                error: "Você precisa cadastrar pelo menos uma data futura"
            })  
        }           

        return errors
    }

    addNewTime() {
        let dateEditing = this.state.dateEditing

        dateEditing.push({
            time: '',
            vacancies: '',
            price: '',
            idEl: Math.random(),
            description: ''
        })

        if(dateEditing && dateEditing.length > 0) {
            dateEditing.sort(function(a,b) {
                let aTime = a.time.replace(':', '')
                let bTime = b.time.replace(':', '')


                aTime = parseInt(aTime, 10)
                bTime = parseInt(bTime, 10)
                return aTime < bTime ? 1 : aTime > bTime ? -1 : 0;
            });
        }

        this.setState({
            dateEditing
        })
    }

    handleAddDate() {
        
        let times = []
        let hasError = false
        this.state.dateEditing.forEach(({ time, vacancies, price, description, id, idEl }) => {
            if(time || vacancies || price || id) {
                let fieldError = false
                if(!time) {
                    fieldError = true
                } else {

                    let timeSplit = time.split(':')
                    if(timeSplit.length < 2) {
                        fieldError = true
                    } else {
                        if(parseInt(timeSplit[0], 10) > 23) fieldError = true
                        if(parseInt(timeSplit[1], 10) > 59) fieldError = true
                    }
                }

                if(fieldError && this.props.duration !== 'Dia inteiro') {
                    this.refs[`time_${idEl}`].setError('')
                    hasError = true
                }

                if(time.length < 4 && this.props.duration !== 'Dia inteiro') {
                    hasError = true
                }
                
                if(this.props.duration !== 'Dia inteiro') {
                    time = time.length === 4 && time[2] === ':' ? `${time}0` : time.length === 4 ? `0${time}` : (time || '00:00')
                } else {
                    time = '00:00'
                }


                times.push({
                    time,
                    vacancies,
                    price: parseInt(price.replace(/\./g, '').replace(/\,/g, ''), 10),
                    id,
                    description
                })
            }
        })

        if(times.length === 0) {

            this.setState({
                dateStatus: null,
                date: null
            })

            return
        }

        if(hasError) {
            this.setState({
                error: 'Verifique os campos de horário'
            })
            return;
        } 

        let form = {
            times,
            remove: this.state.deleteTimes
        }

        let duplicateDates = this.duplicateDates(this.state.date)
        if(!duplicateDates) return;

        this.handleSaveDates(form, [
            this.state.date,
            ...duplicateDates
        ])   
    }

    handleSaveDates(form, dates) {
        this.setState({
            dateStatus: 'saving'
        })

        let promises = []
        dates.forEach(date => {
            if(this.state.dates[date])
            form.id = this.state.dates[date].id
            else
            delete form.id
            
            form.date = date
            
            let addingDate = addDate(this.props.token, form)
            .then(resp => {
                let dates = this.state.dates
                dates[date] = {
                    id: parseInt(resp.id, 10)
                }
                this.setState({
                    dates,
                    disabledcalendar: true
                })
            })

            promises.push(addingDate)
        })

        Promise.all(promises)
        .then(() => {
            this.setState({
                dateStatus: form.id ? 'saved' : 'created',
                date: null,
                disabledcalendar: false
            })
        })


    }

    duplicateDates(dateStart) {
        let weekDays = this.state.duplicateWeekDays
        let until = this.state.duplicateUntil
        let dates = []

        until = toDate(until)
        dateStart = toDate(dateStart)

        if(weekDays.length === 0 || !until) return [];
        
        let timeDiff = until.getTime() - dateStart.getTime();
        
        if(timeDiff <= 0)
        return []

        let daysDiff = timeDiff/1000/3600/24
        
        if(daysDiff > 90) {
            if(this.refs.untildate) {
                this.refs.untildate.setError('')
            }
            
            this.setState({
                error: 'A data de replicação não pode ser maior que 3 meses'
            })
            return false
        }

        let date = dateStart

        while(date.getTime() < until.getTime()) {
            date.setDate(date.getDate() + 1)
            if(weekDays.indexOf(date.getDay()) > -1)
                dates.push(dateFormat('y-m-d', date))
        }

        return dates
    }

    handleRemoveDate() {
        this.dialog.confirm("Confirmação", "Deseja remover essa data de seu calendário?")
        .then(() => {
            this.setState({
                dateStatus: 'saving'
            })

            let dates = this.state.dates
            let date = dates[this.state.date]

            removeDate(this.props.token, date.id)
            .then(() => {
                delete dates[this.state.date]
                this.setState({
                    dates,
                    date: null,
                    dateStatus: null,
                })
            })
        })
    }

    handleToogleWeekDay({checked, name}) {
        let duplicateWeekDays = this.state.duplicateWeekDays
        name = parseInt(name, 10)
        if(checked)
        duplicateWeekDays.push(name)
        else {
            let inx = duplicateWeekDays.indexOf(name)
            duplicateWeekDays.splice(inx, 1)
        }

        this.setState({
            duplicateWeekDays
        })
    } 

    render() {

        return (
            <ContentInfo
                title='Quais os dias de funcionamento da sua academia?'
                description='Defina os dias em que sua academia abre'
                steps={this.props.steps}
            >
                <Row>
                    <Col size='12 12 12 6' style={{ marginBottom: '30px' }}>
                        {this.state.dateStatus === 'loading' ? (
                            <Loading />
                        ) : (
                            <div className={css.calendar} ref={ref => this.calendar = ref}>
                                <Calendar
                                    prevIcon={() => <FontIcon name='left-arrow' size={18} color="#f50" /> }
                                    nextIcon={() => <FontIcon name='right-arrow' size={18} color="#f50" /> }
                                    dates={Object.keys(this.state.dates)}
                                    currentDate={this.state.date}
                                    handleSetDate={date => this.setDate(date)}
                                    disabled={this.state.disabledcalendar}
                                    justNextDays
                                />

                                <ul className={css.legenda}>
                                    <li>
                                        Dia selecionado
                                    </li>
                                    <li className={css.marked}>
                                        Dia com horários cadastrados
                                    </li>
                                </ul>

                            </div>
                        )}

                    </Col>
                    <Col size='12 12 12 9' ref='input_dates'>
                        {this.state.date && (
                            <div>
                                <Row>
                                    <Col size='12'>
                                        <FormGroup>
                                            <Display size={3}>
                                                {formatedDate(this.state.date)}
                                            </Display>
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {this.state.dateStatus === 'loadingDate' ? (
                                    <Row>
                                        <Col size='12'>
                                            <Loading />
                                        </Col>
                                    </Row>
                                ) : (
                                    <div>
                                        {this.props.duration === 'Dia inteiro' ? (
                                            this.state.dateEditing.map((el, i) => (
                                                <Row spacing='mid' key={el.idEl}>
                                                    <Col size='2'>
                                                        <FormGroup>
                                                            <Text
                                                                label='Vagas'
                                                                mask='######'
                                                                name='vacancies'
                                                                ref={`vacancies_${el.idEl}`}
                                                                value={el.vacancies || ''}
                                                                onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col size='3'>
                                                        <FormGroup>
                                                            <Text
                                                                label='Preço'
                                                                mask='money_br'
                                                                name='price'
                                                                ref={`price_${el.idEl}`}
                                                                value={el.price || ''}
                                                                onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col size='6'>
                                                        <FormGroup>
                                                            <Text
                                                                label='Descrição'
                                                                name='description'
                                                                ref={`description_${el.idEl}`}
                                                                value={el.description || ''}
                                                                onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col size='1' text='right' style={{ paddingTop: '12px' }}>
                                                        {this.state.dateEditing.length-1 === i ? (
                                                            <ActionBtnIcon
                                                                theme='rounded-orange'
                                                                action={() => {
                                                                    this.addNewTime()
                                                                }}
                                                                icon='more'
                                                            />
                                                        ) : (
                                                            <ActionBtnIcon
                                                                theme='rounded-orange'
                                                                action={() => this.removeTime(i)}
                                                                icon='trash'
                                                            />
                                                        )}
                                                    </Col>
                                                </Row>
                                            ))
                                        ) : (
                                            this.state.dateEditing.map((el, i) => (
                                                <Row spacing='mid' key={el.idEl}>
                                                    <Col size='5'>
                                                        <Row spacing='mid'>
                                                            <Col size='5'>
                                                                <FormGroup>
                                                                    <Text
                                                                        label='Hora'
                                                                        mask={el.time.length === 3 ? '#:##' : '##:##'}
                                                                        name='time'
                                                                        ref={`time_${el.idEl}`}
                                                                        value={el.time || ''}                                               
                                                                        onChange={evt => this.handleChangeTime(i, evt.target)}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col size='7'>
                                                                <FormGroup>
                                                                    <Text
                                                                        label='Vagas'
                                                                        mask='######'
                                                                        name='vacancies'
                                                                        ref={`vacancies_${el.idEl}`}
                                                                        value={el.vacancies || ''}
                                                                        onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col size='7'>
                                                        <Row spacing='mid'>  
                                                            <Col size='4'>
                                                                <FormGroup>
                                                                    <Text
                                                                        label='Preço'
                                                                        mask='money_br'
                                                                        name='price'
                                                                        ref={`price_${el.idEl}`}
                                                                        value={el.price || ''}
                                                                        onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col size='6'>
                                                                <FormGroup>
                                                                    <Text
                                                                        label='Descrição'
                                                                        name='description'
                                                                        ref={`description_${el.idEl}`}
                                                                        value={el.description || ''}
                                                                        onChange={evt => this.handleChangeTime(i, evt.target)} 
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col size='2' text='right' style={{ paddingTop: '12px' }}>
                                                                {this.state.dateEditing.length-1 === i ? (
                                                                    <ActionBtnIcon
                                                                        theme='rounded-orange'
                                                                        action={() => {
                                                                            this.addNewTime()
                                                                        }}
                                                                        icon='more'
                                                                    />
                                                                ) : (
                                                                    <ActionBtnIcon
                                                                        theme='rounded-orange'
                                                                        action={() => this.removeTime(i)}
                                                                        icon='trash'
                                                                    />
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            )) 
                                        )}

                                        {this.state.dateStatus === 'saving' ? (
                                            <Row>
                                                <Col size='12' text='right'>
                                                    <Loading style={{ textAlign: 'right' }} />
                                                </Col>
                                            </Row>
                                        ) : (
                                            <div>
                                                
                                                {this.state.dates[this.state.date] ? (
                                                    <Row>
                                                        {this.state.error && (
                                                            <Col size='12'>
                                                                <p style={{ color: 'red', fontWeight: 'bold' }}>{this.state.error}</p>
                                                            </Col>
                                                        )}
                                                        <Col size='7'>
                                                            <Button
                                                                secondary
                                                                onClick={() => this.handleRemoveDate()}
                                                                spacing='mid'>Limpar programação</Button>
                                                        </Col>
                                                        <Col size='5'>
                                                            <Button
                                                                spacing='mid'
                                                                primary
                                                                onClick={() => this.handleAddDate()}>Atualizar</Button>
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    <Row>
                                                        <Col size='12' style={{ marginBottom: '30px' }}>
                                                            <AccordionSection title={() => <span><b>Duplicar</b> este dia</span>}>
                                                                <Row>
                                                                    <Col size='12'>
                                                                        <ul className={css.tagsWeek}>
                                                                            <li><Checktag className={css.checktag} label='D' name={0} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(0) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='S' name={1} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(1) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='T' name={2} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(2) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='Q' name={3} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(3) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='Q' name={4} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(4) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='S' name={5} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(5) > -1 ? true : false} /></li>
                                                                            <li><Checktag className={css.checktag} label='S' name={6} onChange={e => this.handleToogleWeekDay(e.target)} checked={this.state.duplicateWeekDays.indexOf(6) > -1 ? true : false} /></li>
                                                                        </ul>
                                                                    </Col>
                                                                </Row>
                                                                
                                                                <Row spacing='mid' alignItems='center'>
                                                                    <Col size='7'>
                                                                        <FormGroup>
                                                                            <Text
                                                                                label='Até o dia'
                                                                                mask='##/##/####'
                                                                                ref='untildate'
                                                                                value={this.state.duplicateUntil}
                                                                                onChange={(evt) => this.setState({
                                                                                    duplicateUntil: evt.target.value
                                                                                })} />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col size='5'>
                                                                        <FormGroup>
                                                                            Máximo 3 meses após
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </AccordionSection>
                                                        </Col>
                                                        
                                                        {this.state.error && (
                                                            <Col size='12'>
                                                                <p style={{ color: 'red', fontWeight: 'bold' }}>{this.state.error}</p>
                                                            </Col>
                                                        )}

                                                        <Col size='12' text='right'>
                                                            <Button
                                                                inline
                                                                primary
                                                                spacing='mid'
                                                                onClick={() => this.handleAddDate()}
                                                            >
                                                                Criar dia de funcionamento
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {(this.state.dateStatus === 'created' || this.state.dateStatus === 'saved') && (
                            <div>
                                <Display size='3'><b>O dia de funcionamento</b> foi {this.state.dateStatus === 'saved' ? `alterado` : `cadastrado`} com sucesso</Display>
                                <p>
                                    Você ainda pode adicionar mais dias e vagas disponíveis da sua academia selecionando o dia da sua preferência.
                                </p>
                                <p>
                                    Caso você já tenha informado todos os dias e horários disponíveis, você pode publicar sua academia agora.
                                </p>
                            </div>
                        )}
                    </Col>
                </Row>
                    
                    <Dialog ref={ref => this.dialog = ref} />
            </ContentInfo>
        )
    }

}

export default CalendarStep


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Steps/Calendar/index.js